(ns common.schema.entities.counterparty-diligence.templates.questions.legal-entity
  (:require
   [common.country :as country]))

(def company-name
  {:field     :legal-entity/company-name
   :label     {:en "Name of the company"}
   :data-type :data.type/text-simple})

(def business-id
  {:field     :legal-entity/business-id
   :label     {:en "Business ID"}
   :data-type :data.type/text-simple})

(def jurisdiction
  {:field     :legal-entity/jurisdiction
   :label     {:en "Company's jurisdiction"}
   :data-type :data.type/keyword
   :options   country/options})

(def company-legal-form
  {:field     :legal-entity/company-legal-form
   :label     {:en "Company's legal form"}
   :data-type :data.type/keyword
   :options [{:value :legal-form/limited-company
              :label {:en "Limited liability company"
                      :fi "Osakeyhtiö"}}
             {:value :legal-form/other
              :label {:en "Other"
                      :fi "Muu"}}]})

(def company-legal-form-other
  {:field     :legal-entity/company-legal-form-other
   :label     {:en "Specify the company's legal form"}
   :data-type :data.type/text-simple})

(def trade-register-extract-or-eq
  {:field     :legal-entity/trade-register-extract-or-equivalent
   :label     {:en "Trade register extract or equivalent"}
   :data-type :data.type/file})

(def articles-of-association-or-equivalent-or-eq
  {:field     :legal-entity/articles-of-association-or-equivalent
   :label     {:en "Articles of association or equivalent"}
   :data-type :data.type/file})
